import {Base} from '../../common/model/base.model';
import {TableRow} from '../../common/model/table-row.model';
import {TableRowValue} from '../../common/model/table-row-value.model';
import {TipoEntitaOrganizzativa} from '../tipoentitaorganizzativa/tipoentitaorganizzativa.model';

export class CategoriaTipiEo extends Base {

  constructor(protected id: number,
              public descr: string,
              public sigla: string,
              public tipi: TipoEntitaOrganizzativa[]) {
    super(id);
  }

  public static getTableKeys() {
    return ['id', 'descr', 'sigla', 'tipi'];
  }

  public getLabel() {
    return this.descr;
  }

  public toTableRow(): TableRow {
    const rowValues = new Map();
    rowValues.set('id', new TableRowValue(this.id, null));
    rowValues.set('descr', new TableRowValue(this.descr, null));
    rowValues.set('sigla', new TableRowValue(this.sigla, null));
    rowValues.set('tipi', new TableRowValue(this.tipi.length, null));
    return new TableRow(this, rowValues);
  }

}
